import { generateActions } from "../utils";

export const SIGN_UP = generateActions("SIGN_UP");
export const SIGN_IN = generateActions("SIGN_IN");
export const VERIFY_EMAIL = generateActions("VERIFY_EMAIL");
export const LOST_PASSWORD = generateActions("LOST_PASSWORD");
export const RESET_PASSWORD = generateActions("RESET_PASSWORD");
